export default __webpack_public_path__ + "static/paweta-e5b8daac9205f8c72d1fea4275dc6a90.jpeg";